function Header() {
  return (
    <div className="links row float-right">
      <div className="icon col-4">
        <div className="box">
          <a href="https://twitter.com/Red_Yoshi_" target="_blank"><img src={`${process.env.PUBLIC_URL}/twitter.png`}/></a>
        </div>
      </div>
      <div className="icon col-4">
        <div className="box">
          <a href="https://www.youtube.com/channel/UCZP0RtTNhCzItllYmJbTqwg" target="_blank"><img src={`${process.env.PUBLIC_URL}/youtube.jpg`}/></a>
        </div>
      </div>
      <div className="icon col-4">
        <div className="box">
          <a href="https://nana-music.com/users/10113135" target="_blank"><img src={`${process.env.PUBLIC_URL}/nana.png`}/></a>
        </div>
      </div>
    </div>
  )
}

export default Header;